import React, { Suspense } from 'react';

export const TreatmentComponent = React.lazy(() => import('./Treatment'));

export const Treatment = () => (
  <Suspense fallback={null}>
    <TreatmentComponent />
  </Suspense>
);
